import { DECEASED_DETAILS_FIELD_SET_VALID, DECEASED_DETAILS_SET_VALUE, FORM_INVALID_TRANSITION_DECEASED_DETAILS, FORM_VALID_TRANSITION_DECEASED_DETAILS } from '../../actions/kaMetlhaFuneralClaim/deceasedDetails';
import { FIELD_STATUS, FORM_STATUS } from '../status';

export const initDeceasedDetails = {
    formStatus: FORM_STATUS.INVALID,
    form: {
        deceasedRelation:{
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        relationShip:{
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        title: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        firstName: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        middleName: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        lastName: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        idSelected: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        accountHolderId: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        dateOfDeath: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        // yearsOfDeath:{
        //     displayValue: null,
        //     value: null,
        //     error: null,
        //     status: null,
        // },
        reasonForDelay:{
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        placeOfDeath: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        cause: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        mentionedCause: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },

    },
};
// const initialAction={type:"",value:{fieldType:"",value:""}}
export default (state = initDeceasedDetails, action) => {
    const trimField = (value) => (value ? value.trim() : value);
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    // if ( CLAIMENT_DETAILS_SET_VALUE) {
        switch (action.type) {
            case FORM_VALID_TRANSITION_DECEASED_DETAILS:
                return { ...state, formStatus: FORM_STATUS.VALID };
            case FORM_INVALID_TRANSITION_DECEASED_DETAILS:
                return { ...state, formStatus: FORM_STATUS.INVALID };
            case DECEASED_DETAILS_SET_VALUE:
                return updateFormField(action.value.fieldType, (field) => ({
                    ...field,
                    displayValue: action.value.displayValue ?? action.value.value,
                    value: trimField(action.value.value),
                }));

            case DECEASED_DETAILS_FIELD_SET_VALID:
                const {fieldType,error}=action
                return  updateFormField(fieldType, (field) => ({
                    ...field,
                    error: error,
                    status: mapError(error),
                  }));
            default:
                return state;
        // }
    } 
};
